/**
 * A location description.
 *
 * @property {string} address   - Formatted address
 * @property {Object} params    - Map of key value pairs with the parameter name as the key (string) and the
 *                                  parameter value as the value (string).
 */
export class LocationDescription {
    /**
     * Creates a new location description.
     *
     * @param {String} [address]    - Formatted address
     * @param {Object} [params]     - Map of key value pairs with the parameter name as the key (string) and the
     *                                  parameter value as the value (string).
     */
    constructor(address = null, params = null) {
        this.address = address
        this.params = params
    }
}
